/* corex-textil-filtros.js · «Encuentra tu prenda en un clic»: filtros por botones de la sección textil.
   Datos: templates/collection.filtros-json.liquid (corex.filtros de cada prenda, que rellena el importador, y los
   colores con stock). Los botones del mismo grupo suman (o), los de grupos distintos restringen (y). Solo se
   enseñan los grupos con al menos dos valores con resultados (la fila de populares, con uno basta) y se desactivan
   los botones que darían 0. Sin filtros activos no se enseñan resultados (en una colección, la cuadrícula normal).
   El título y la fila «Lo más buscado» vienen pintados desde Liquid (desactivados) para que el bloque no aparezca
   de golpe; al llegar los datos se repintan con los valores que tienen prendas. Resultados: de menor a mayor precio
   (el del cliente, el más bajo de la prenda), «desde X» si las variantes tienen precios distintos; para consumidores,
   los destacados (p.d) primero.
   Móvil (≤ 600 px): arriba «Lo más buscado» y el botón «Filtrar» (con el nº de filtros activos); el resto de grupos va
   en un panel desde abajo con «Ver N prendas» (en vivo) y «Quitar filtros»; se cierra con ✕, el fondo, Esc o
   deslizando hacia abajo. En escritorio el panel no se ve como tal (CSS: display contents) y todo sigue igual. */
(function () {
  'use strict';

  var GRUPOS = [
    { id: 'populares', label: 'Lo más buscado', valores: [['oversize', 'Oversize'], ['crop-top', 'Crop Top'], ['tank', 'Tank (tirantes)']], minimo: 1 },
    { id: 'prenda', label: 'Prenda', valores: [['camiseta', 'Camiseta'], ['sudadera', 'Sudadera'], ['chaqueta', 'Chaqueta'], ['pantalon', 'Pantalón / Malla'], ['polo', 'Polo'],
      ['camisa', 'Camisa'], ['vestido', 'Vestido'], ['sujetador', 'Top / Sujetador'], ['accesorio', 'Accesorio'], ['bebe', 'Bebé'], ['workwear', 'Workwear']] },
    { id: 'tipo', label: 'Tipo', valores: [['con-capucha', 'Con capucha'], ['sin-capucha', 'Sin capucha'], ['cremallera', 'Con cremallera'], ['cuarto-cremallera', '1/4 cremallera'], ['cuello-redondo', 'Cuello redondo']] },
    { id: 'manga', label: 'Manga', valores: [['corta', 'Corta'], ['larga', 'Larga'], ['sin', 'Sin mangas']] },
    { id: 'corte', label: 'Corte', valores: [['regular', 'Regular'], ['oversize', 'Oversize'], ['crop', 'Crop'], ['hombros-caidos', 'Hombros caídos']] },
    { id: 'genero', label: 'Género', valores: [['hombre', 'Hombre'], ['mujer', 'Mujer'], ['unisex', 'Unisex'], ['nino', 'Niño']] },
    { id: 'color', label: 'Color', valores: [['negro', 'Negro', '#1f1f1f'], ['blanco', 'Blanco', '#ffffff'], ['gris', 'Gris', '#9a9a9f'], ['azul', 'Azul', '#2852a8'],
      ['rojo', 'Rojo', '#c8202e'], ['verde', 'Verde', '#3f7a4a'], ['amarillo', 'Amarillo', '#f2c230'], ['naranja', 'Naranja', '#f07a1a'], ['rosa', 'Rosa', '#ec7fa9'],
      ['morado', 'Morado', '#7b4ba1'], ['marron-beige', 'Marrón / Beige', '#a8835c'], ['multicolor', 'Multicolor', 'conic-gradient(#c8202e,#f2c230,#3f7a4a,#2852a8,#7b4ba1,#c8202e)']] }
  ];

  /* Valores de un producto en un grupo (lista). Color: familias de los colores con stock. */
  function valores(p, g) {
    var f = p.f || {};
    if (g === 'color') {
      var fam = {}, map = f.colores || {};
      (p.c || []).forEach(function (c) { if (map[c]) fam[map[c]] = 1; });
      return Object.keys(fam);
    }
    var v = f[g];
    return v == null ? [] : [].concat(v);
  }
  function cumple(p, sel, sin) {
    return Object.keys(sel).every(function (g) {
      if (g === sin || !sel[g].length) return true;
      var vs = valores(p, g);
      return sel[g].some(function (x) { return vs.indexOf(x) >= 0; });
    });
  }
  function varia(p) { return p.px != null && p.pn != null ? p.px > p.pn : !!p.pv; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function cargar(fuente) {
    var todos = [];
    function pagina(n) {
      return fetch(fuente + (fuente.indexOf('?') >= 0 ? '&' : '?') + 'view=filtros-json&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          /* Shopify puede añadir comentarios HTML alrededor (vista previa de tema): solo el objeto JSON */
          var d = JSON.parse(t.slice(t.indexOf('{'), t.lastIndexOf('}') + 1));
          todos = todos.concat(d.productos || []);
          return d.pagina < d.paginas ? pagina(n + 1) : todos;
        });
    }
    return pagina(1);
  }

  function montar(root) {
    var fija = {};
    try { fija = JSON.parse(root.getAttribute('data-fija') || '{}'); } catch (e) { fija = {}; }
    var ocultar = root.getAttribute('data-ocultar') ? document.querySelector(root.getAttribute('data-ocultar')) : null;
    var chips = root.querySelector('[data-cxf-chips]'), res = root.querySelector('[data-cxf-res]'), cuenta = root.querySelector('[data-cxf-cuenta]');
    var quitar = root.querySelector('[data-cxf-quitar]'), grid = root.querySelector('[data-cxf-grid]'), ayuda = root.querySelector('template[data-cxf-ayuda]');
    var sel = {}, base = [], sheet = null, panel = null, abrirBtn = null, hueco = null;
    GRUPOS.forEach(function (g) { sel[g.id] = []; });

    cargar(root.getAttribute('data-fuente')).then(function (ps) {
      /* base: las prendas de esta página (en una categoría, solo las de su prenda) con datos de filtros */
      base = ps.filter(function (p) { return p.f && Object.keys(fija).every(function (g) { return valores(p, g).indexOf(fija[g]) >= 0; }); })
        .sort(function (a, b) { return (b.d ? 1 : 0) - (a.d ? 1 : 0) || (a.pn || 0) - (b.pn || 0); });
      pintarChips();
      root.hidden = !base.length;
    }).catch(function () { root.hidden = true; });

    function visibles() {
      return GRUPOS.filter(function (g) { return !fija[g.id]; }).map(function (g) {
        var vals = g.valores.filter(function (v) { return base.some(function (p) { return valores(p, g.id).indexOf(v[0]) >= 0; }); });
        return { g: g, vals: vals };
      }).filter(function (x) { return x.vals.length >= (x.g.minimo || 2); });
    }
    function fila(x) {
      return '<div class="cxf-fila' + (x.g.id === 'populares' ? ' cxf-fila--pop' : '') + '" role="group" aria-label="' + esc(x.g.label) + '">' +
        '<span class="cxf-fila__t">' + esc(x.g.label) + '</span><div class="cxf-fila__chips">' +
        x.vals.map(function (v) {
          var dot = x.g.id === 'color' ? '<i class="cxf-dot" style="background:' + v[2] + '"></i>' : '';
          return '<button type="button" class="cxf-chip" data-g="' + x.g.id + '" data-v="' + v[0] + '" aria-pressed="false">' + dot + esc(v[1]) + '</button>';
        }).join('') + '</div></div>';
    }
    function pintarChips() {
      var vis = visibles(), pop = vis.filter(function (x) { return x.g.id === 'populares'; }), resto = vis.filter(function (x) { return x.g.id !== 'populares'; });
      chips.innerHTML = '<div class="cxf-top">' + pop.map(fila).join('') +
        (resto.length ? '<button type="button" class="cxf-abrir" data-cxf-abrir aria-haspopup="dialog" aria-expanded="false">' +
          '<svg class="cxf-abrir__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M4 6h16M7 12h10M10 18h4"/></svg>' +
          'Filtrar<span class="cxf-abrir__n" data-cxf-nact hidden></span></button>' : '') + '</div>' +
        '<div class="cxf-sheet" data-cxf-sheet><div class="cxf-sheet__fondo" data-cxf-cerrar></div>' +
        '<div class="cxf-sheet__panel" data-cxf-panel aria-label="Filtros">' +
        '<div class="cxf-sheet__h" data-cxf-asa><span class="cxf-sheet__asa" aria-hidden="true"></span><span class="cxf-sheet__t">Filtrar</span>' +
        '<button type="button" class="cxf-x" data-cxf-cerrar aria-label="Cerrar filtros">✕</button></div>' +
        '<div class="cxf-sheet__body">' + resto.map(fila).join('') + '</div>' +
        '<div class="cxf-sheet__pie"><button type="button" class="cxf-quitar2" data-cxf-quitar2>Quitar filtros</button>' +
        '<button type="button" class="cxf-ver" data-cxf-ver></button></div></div></div>';
      sheet = chips.querySelector('[data-cxf-sheet]');
      panel = chips.querySelector('[data-cxf-panel]');
      abrirBtn = chips.querySelector('[data-cxf-abrir]');
      arrastre(chips.querySelector('[data-cxf-asa]'));
      /* al abrirse el panel se mueve al final de <body> (por encima de la cabecera fija y de otros botones flotantes):
         sus clics se atienden aquí y no suben, para no contarlos dos veces cuando está en su sitio */
      if (sheet) sheet.addEventListener('click', function (e) { alClic(e); e.stopPropagation(); });
      actualizar();
    }
    /* los del bloque y los del panel (que, abierto, está al final de <body>) */
    function todosLosChips() {
      var l = [].slice.call(chips.querySelectorAll('.cxf-chip'));
      return sheet && !chips.contains(sheet) ? l.concat([].slice.call(sheet.querySelectorAll('.cxf-chip'))) : l;
    }
    function actualizar() {
      var activos = Object.keys(sel).some(function (g) { return sel[g].length; });
      var lista = base.filter(function (p) { return cumple(p, sel); });
      todosLosChips().forEach(function (b) {
        var g = b.getAttribute('data-g'), v = b.getAttribute('data-v'), on = sel[g].indexOf(v) >= 0;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        /* ¿daría resultados si se marca? (con el resto de grupos como están) */
        var n = on ? 1 : base.filter(function (p) { return cumple(p, sel, g) && valores(p, g).indexOf(v) >= 0; }).length;
        b.disabled = !on && n === 0;
      });
      res.hidden = !activos;
      quitar.hidden = !activos;
      var nAct = Object.keys(sel).reduce(function (n, g) { return n + sel[g].length; }, 0), nVer = activos ? lista.length : base.length;
      var nact = abrirBtn && abrirBtn.querySelector('[data-cxf-nact]'), ver = sheet && sheet.querySelector('[data-cxf-ver]'), q2 = sheet && sheet.querySelector('[data-cxf-quitar2]');
      if (nact) { nact.hidden = !nAct; nact.textContent = nAct; }
      if (abrirBtn) abrirBtn.setAttribute('aria-label', 'Filtrar' + (nAct ? ' (' + nAct + (nAct === 1 ? ' filtro activo)' : ' filtros activos)') : ''));
      if (ver) { ver.textContent = 'Ver ' + nVer + (nVer === 1 ? ' prenda' : ' prendas'); ver.disabled = !nVer && !ayuda; }
      if (q2) q2.disabled = !nAct;
      if (ocultar) ocultar.style.display = activos ? 'none' : '';
      if (!activos) return;
      cuenta.textContent = lista.length + (lista.length === 1 ? ' prenda' : ' prendas');
      /* sin prendas y con ayuda (consumidores en Personalización Textil): «¿No encuentras lo que buscas?» + WhatsApp */
      if (!lista.length && ayuda) {
        cuenta.textContent = 'Ninguna prenda con estos filtros';
        grid.innerHTML = ayuda.innerHTML;
        if (window.cxWaPreparar) window.cxWaPreparar();
        return;
      }
      grid.innerHTML = lista.map(function (p) {
        /* p.sd: HTML del precio para consumidores, generado por el tema (snippets/corex-precio-personalizada.liquid) */
        var badge = p.d ? '<span class="cx-dest-badge">' + esc(p.d) + '</span>' : '';
        return '<a class="cxf-card' + (p.d ? ' cx-dest' : '') + '" href="' + esc(p.u) + '">' +
          (p.i ? '<span class="cxf-card__img">' + badge + '<img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" loading="lazy" width="240" height="240"></span>' : '<span class="cxf-card__img">' + badge + '</span>') +
          '<span class="cxf-card__t">' + esc(p.t) + '</span><span class="cxf-card__p">' + (p.sd ? p.sd : (varia(p) ? 'desde ' : '') + esc(p.p)) + '</span></a>';
      }).join('');
    }
    function quitarTodo() { Object.keys(sel).forEach(function (g) { sel[g] = []; }); actualizar(); }
    chips.addEventListener('click', alClic);
    function alClic(e) {
      if (e.target.closest('[data-cxf-abrir]')) return abrir();
      if (e.target.closest('[data-cxf-cerrar]')) return cerrar();
      if (e.target.closest('[data-cxf-quitar2]')) return quitarTodo();
      if (e.target.closest('[data-cxf-ver]')) {
        cerrar();
        var destino = Object.keys(sel).some(function (g) { return sel[g].length; }) ? res : (ocultar || root);
        return destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      var b = e.target.closest('.cxf-chip');
      if (!b || b.disabled) return;
      var g = b.getAttribute('data-g'), v = b.getAttribute('data-v'), i = sel[g].indexOf(v);
      if (i >= 0) sel[g].splice(i, 1); else sel[g].push(v);
      actualizar();
    }
    quitar.addEventListener('click', quitarTodo);

    /* ---------- panel de filtros (móvil) ---------- */
    function abierto() { return !!sheet && sheet.classList.contains('is-open'); }
    function abrir() {
      if (!sheet) return;
      if (!hueco) { hueco = document.createComment('cxf-panel'); sheet.parentNode.insertBefore(hueco, sheet); }
      document.body.appendChild(sheet);
      sheet.classList.add('is-open');
      panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true');
      if (abrirBtn) abrirBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('cxf-noscroll');
      var x = sheet.querySelector('.cxf-x'); if (x) x.focus();
    }
    function cerrar() {
      if (!abierto()) return;
      sheet.classList.remove('is-open');
      if (hueco && hueco.parentNode) hueco.parentNode.insertBefore(sheet, hueco.nextSibling);
      panel.removeAttribute('role'); panel.removeAttribute('aria-modal'); panel.style.transform = '';
      if (abrirBtn) { abrirBtn.setAttribute('aria-expanded', 'false'); abrirBtn.focus({ preventScroll: true }); }
      document.documentElement.classList.remove('cxf-noscroll');
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && abierto()) cerrar(); });
    /* al pasar a escritorio con el panel abierto, se cierra (el escritorio no tiene panel) */
    if (window.matchMedia) {
      var mq = window.matchMedia('(max-width: 600px)'), alCambiar = function () { if (!mq.matches) cerrar(); };
      if (mq.addEventListener) mq.addEventListener('change', alCambiar); else if (mq.addListener) mq.addListener(alCambiar);
    }
    /* deslizar hacia abajo desde la cabecera del panel para cerrarlo */
    function arrastre(asa) {
      if (!asa) return;
      var y0 = null, dy = 0;
      asa.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; dy = 0; panel.style.transition = 'none'; }, { passive: true });
      asa.addEventListener('touchmove', function (e) {
        if (y0 == null) return;
        dy = Math.max(0, e.touches[0].clientY - y0);
        panel.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: true });
      asa.addEventListener('touchend', function () {
        if (y0 == null) return;
        panel.style.transition = ''; y0 = null;
        if (dy > 90) cerrar(); else panel.style.transform = '';
      });
    }
  }

  function iniciar() { [].forEach.call(document.querySelectorAll('[data-cxf]'), montar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
